export const getModels = (resolve, reject, tokenId, enabled) => {
  let reqBodyCondi = {};
  if (enabled !== null && enabled !== undefined) {
    reqBodyCondi = {
      Enabled: enabled
    }
  }

  let req = new Request(window.CONFIG.AWS_URL + '/getallmodels', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : tokenId,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(reqBodyCondi)
  });

  fetch(req)
  .then((response) => {
    if (response.ok) {
      if (response.json) {
        resolve(response.json());
      } else {
        reject('getModels response format error.');
      }
    } else {
      reject('getModels response error.');
    }            
  }).catch((err) => {
    reject(err);
  });
}

export const getModelStatus = (resolve, reject, tokenId, modelName) => {
  let req = new Request(window.CONFIG.AWS_URL + '/getmodelstatus', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : tokenId,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      modelName: modelName
    })
  });

  fetch(req)
  .then((response) => {
    if (response.ok) {
      if (response.json) {
        resolve(response.json());
      } else {
        reject('getModelStatus response format error.');
      }
    } else {
      reject('getModelStatus response error.');
    }            
  }).catch((err) => {
    reject(err);
  });
}

export const addModel = (resolve, reject, tokenId, reqBodyObj) => {
  let req = new Request(window.CONFIG.AWS_URL + '/addmodel', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : tokenId,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(reqBodyObj)
  });

  fetch(req)
  .then((response) => {
    if (response.ok) {
      if (response.json) {
        resolve(response.json());
      } else {
        reject('addModel response format error.');
      }
    } else {
      reject('addModel response error.');
    }            
  }).catch((err) => {
    reject(err);
  });
}

export const editModel = (resolve, reject, tokenId, reqBodyObj) => {
  let req = new Request(window.CONFIG.AWS_URL + '/editmodel', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : tokenId,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(reqBodyObj)
  });

  fetch(req)
  .then((response) => {
    if (response.ok) {
      if (response.json) {
        resolve(response.json());
      } else {
        reject('editModel response format error.');
      }
    } else {
      reject('editModel response error.');
    }            
  }).catch((err) => {
    reject(err);
  });
}

export const deleteModel = (resolve, reject, tokenId, modelName) => {
  let req = new Request(window.CONFIG.AWS_URL + '/delmodel', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : tokenId,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      modelName: modelName
    })
  });

  fetch(req)
  .then((response) => {
    if (response.ok) {
      if (response.json) {
        resolve(response.json());
      } else {
        reject('deleteModel response format error.');
      }
    } else {
      reject('deleteModel response error.');
    }            
  }).catch((err) => {
    reject(err);
  });
}